import { useContext } from 'react';
import { Trash } from '@styled-icons/fa-solid';
import { OverlayTrigger, Popover, PopoverContent } from 'react-bootstrap';
import BPHeader from './BPHeader';
import BPFooter from './BPFooter';
import BPGrid from './BPTestTable';
import { BusinessPartnerContext } from './BusinessPartnerCard';
import { trimIfString } from '../../utils/stringUtils';

const WarningIcon = ({ errorMessage }) => (
  <OverlayTrigger
    placement="top"
    trigger={['hover', 'focus']}
    overlay={
      <Popover style={{ minWidth: 'auto' }}>
        <PopoverContent>{errorMessage}</PopoverContent>
      </Popover>
    }
  >
    <p className="bp-warning-paragraph">
      <span className="warning bp-warning" aria-label="Validation error" />
    </p>
  </OverlayTrigger>
);

const BPContacts = () => {
  const { localBPData, isEditing, errors, handleContactsChange, handleContactDelete } =
    useContext(BusinessPartnerContext);

  const contacts = localBPData['Contacts'] || Array.from({ length: 5 }, () => ({ contactName: '', contactEmail: '' }));
  const rows = Array.isArray(contacts) ? contacts.slice(0, 5) : [];
  while (rows.length < 5) {
    rows.push({ contactName: '', contactEmail: '' });
  }

  return (
    <>
      <section className="bp-address">
        <BPHeader />
        <div>
          <div className="bp-section-heading">Contacts</div>
          <BPGrid className="address" numCols={3} style={{ gridTemplateColumns: '1fr 1fr 80px' }}>
            <BPGrid.Header>Contact Name</BPGrid.Header>
            <BPGrid.Header>Contact Email</BPGrid.Header>
            <BPGrid.Header>Action</BPGrid.Header>
            {rows.flatMap((row, index) => {
              const emailErrorKey = `Contacts_email_${index}`;
              const contactNameErrorKey = `Contacts_contactName_${index}`;
              const hasEmailError = errors?.[emailErrorKey];
              const hasContactNameError = errors?.[contactNameErrorKey];
              const hasRowError = hasEmailError || hasContactNameError;
              return [
                <div
                  key={`${index}-0`}
                  className={`bp-table-grid-cell bp-grid-default ${hasRowError ? 'bp-grid-error-cell' : ''}`}
                >
                  {isEditing ? (
                    <>
                      <input
                        type="text"
                        className={`input-element ${hasContactNameError ? 'is-invalid' : ''}`}
                        value={row.contactName || ''}
                        onChange={(e) => handleContactsChange(index, 'contactName', e.target.value)}
                      />
                      {hasContactNameError && <WarningIcon errorMessage={errors[contactNameErrorKey]} />}
                    </>
                  ) : (
                    <>
                      <p className="bpgrid-value">{row.contactName || ''}</p>
                      {hasContactNameError && <WarningIcon errorMessage={errors[contactNameErrorKey]} />}
                    </>
                  )}
                </div>,
                <div
                  key={`${index}-1`}
                  className={`bp-table-grid-cell bp-grid-default ${hasRowError ? 'bp-grid-error-cell' : ''}`}
                >
                  {isEditing ? (
                    <>
                      <input
                        type="text"
                        className={`input-element ${hasEmailError ? 'is-invalid' : ''}`}
                        value={row.contactEmail || ''}
                        onChange={(e) => handleContactsChange(index, 'contactEmail', trimIfString(e.target.value))}
                      />
                      {hasEmailError && <WarningIcon errorMessage={errors[emailErrorKey]} />}
                    </>
                  ) : (
                    <>
                      <p className="bpgrid-value">{row.contactEmail || ''}</p>
                      {hasEmailError && <WarningIcon errorMessage={errors[emailErrorKey]} />}
                    </>
                  )}
                </div>,
                <div key={`${index}-2`} className="bp-table-grid-cell bp-grid-default bp-contacts-action-cell">
                  {isEditing &&
                    ((row.contactName || '').trim() || (row.contactEmail || '').trim() || row?.id != null) && (
                      <button
                        type="button"
                        className="bp-contacts-delete-btn"
                        onClick={() => handleContactDelete(index)}
                        aria-label="Delete contact"
                      >
                        <Trash width="1rem" height="1rem" />
                      </button>
                    )}
                </div>,
              ];
            })}
          </BPGrid>
        </div>
      </section>
      <BPFooter />
    </>
  );
};

export default BPContacts;
